/** Query parameters of the review link: /extraction/<doctype>?processId=...&processItemId=... */
export const REVIEW_PROCESS_PARAM = "processId";
export const REVIEW_ITEM_PARAM = "processItemId";

/**
 * Review link for one extracted document. Built from the current location so
 * it carries whatever base path the module is mounted under (/extraction in the
 * shell, / standalone); the current page must be the doctype page.
 */
export const buildReviewLink = (
  processId: string,
  processItemId: string,
  href: string = window.location.href,
): string => {
  const url = new URL(href);
  url.search = "";
  url.hash = "";
  url.searchParams.set(REVIEW_PROCESS_PARAM, processId);
  url.searchParams.set(REVIEW_ITEM_PARAM, processItemId);
  return url.toString();
};
